module.exports = __webpack_public_path__ + "img/jifen6.44ec4c46.png";